import { TableCell } from "@tiptap/extension-table"

export const ColorTableCell = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            backgroundColor: {
                default: null,
                parseHTML: el => el.getAttribute('backgroundColor'),
                renderHTML: attributes => {
                    return {
                        'backgroundColor': attributes.backgroundColor,
                        style: `background-color: ${attributes.backgroundColor}`,
                    }
                },
            },
        }
    },
});
